var CIDSerialiser = require('conversation/conversation-id-serialiser');
var UpdateSerialiser = require('update/serialiser');
var Codec = require('io/codec');

module.exports = {
    read : function(input) {
        var cid = CIDSerialiser.read(input);
        var path = Codec.readString(input);
        var val = UpdateSerialiser.read(input);

        return { cid : cid, path : path, update : val };
    },
    write : function(output, req) {
        CIDSerialiser.write(output, req.cid);
        Codec.writeString(output, req.path);
        UpdateSerialiser.write(output, req.update);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-update-serialiser.js
// module id = 1037
// module chunks = 1